const styles = theme => ({
  root: {
    width: '100%',
    padding: theme.spacing(3)
  }
});

export default styles;
